<div class="overflow-x-auto rounded-xl border border-base-300">
  <table class="table table-fixed w-full" [class.!border-t-0]="!options()?.header?.show">
    <thead>
      <tr class="bg-base-200/50">
        @for (column of columns(); track column.field) {
          @let isOpenMenu =
            !column?.filter?.disabled &&
            showHeaderOption() &&
            column?.field !== 'rowNumber' &&
            column?.field !== 'checkbox';

          <th
            gridColumn
            [(align)]="align"
            [(orderBy)]="orderBy"
            [(selecteds)]="selecteds"
            [column]="column"
            [showHeaderOption]="showHeaderOption()"
            [class.open-menu]="isOpenMenu"
            class="border-0 text-sm font-semibold text-base-content/50 uppercase tracking-wide"
            [ngClass]="[column.type === 'checkbox' ? 'left-0 sticky z-10' : '', column.style?.columnClass || '']"></th>
        }
      </tr>
    </thead>
    <tbody
      cdkDropList
      [cdkDropListDisabled]="!dragDropEnabled"
      (cdkDropListDropped)="onDrop($event)"
    >
      @for (row of rowData(); track row.uniqueId) {
        <tr
          cdkDrag
          [cdkDragDisabled]="!dragDropEnabled"
          animate.enter="fade-in"
          gridRow
          class="hover:bg-base-200/30 transition-colors"
          [class.cursor-pointer]="options()?.row?.clickHandler"
          [columns]="columns()!"
          [row]="row"
          [(selecteds)]="selecteds"></tr>
      } @empty {
        <tr>
          <td [attr.colspan]="columns().length" class="text-center">
            <div class="flex flex-col items-center justify-center py-15 gap-3">
              <span class="icon-[mdi--magnify] text-4xl text-base-content/20"></span>
              <p class="font-medium text-base-content/40">검색 결과를 찾을 수 없습니다.</p>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
